import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "leads scroll-wrapper" }
const _hoisted_4 = { class: "leads-header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "wrapper-table" }
const _hoisted_7 = { class: "table-scroll" }
const _hoisted_8 = { class: "table-default" }
const _hoisted_9 = { class: "select" }
const _hoisted_10 = ["value", "id"]
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "email" }
const _hoisted_13 = { class: "phone" }
const _hoisted_14 = { class: "input-row" }
const _hoisted_15 = { class: "input-wr" }
const _hoisted_16 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_17 = { class: "input-wr" }
const _hoisted_18 = { class: "input-row" }
const _hoisted_19 = { class: "input-wr" }
const _hoisted_20 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_21 = { class: "controls" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    showClose: false,
    classes: "send-contract-form-modal"
  }, _createSlots({ _: 2 }, [
    (!$setup.isLoading)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-title" }, "Send Contract Information Form", -1)),
                _createVNode($setup["InputSearch"], {
                  class: "search",
                  modelValue: $setup.searchQuery,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
                  placeholder: "Search",
                  theme: "filter"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["items-count", { 'items-count-no-leads': !$setup.leadsAndContactsList.length && $setup.searchQuery }])
                }, _toDisplayString($setup.itemsCountText), 3)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  ($setup.leadsAndContactsList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("table", _hoisted_8, [
                              _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "select-lead" }),
                                  _createElementVNode("th", { class: "name" }, "Name"),
                                  _createElementVNode("th", { class: "email" }, "Email"),
                                  _createElementVNode("th", { class: "phone" }, "Phone")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.leadsAndContactsList, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", _hoisted_9, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedLeadOrContactId) = $event)),
                                        value: item._id,
                                        id: item._id,
                                        type: "radio",
                                        class: _normalizeClass({ selected: $setup.selectedLeadOrContactId === item._id })
                                      }, null, 10, _hoisted_10), [
                                        [_vModelRadio, $setup.selectedLeadOrContactId]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_11, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.email), 1),
                                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.phone), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        class: "default-form",
                        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["input", { error: $setup.v$.firstName.$error }]),
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.firstName) = $event)),
                              type: "text",
                              placeholder: "First Name"
                            }, null, 2), [
                              [_vModelText, $setup.form.firstName]
                            ]),
                            ($setup.v$.firstName.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.v$.firstName.$errors[0].$message), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: "input",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.lastName) = $event)),
                              type: "text",
                              placeholder: "Last Name"
                            }, null, 512), [
                              [_vModelText, $setup.form.lastName]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["input", { error: $setup.v$.firstName.$error }]),
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.email) = $event)),
                              type: "text",
                              placeholder: "Email",
                              onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.v$.email.$touch()))
                            }, null, 34), [
                              [_vModelText, $setup.form.email]
                            ]),
                            ($setup.v$.email.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 32))
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "button default",
                  onClick: $setup.close
                }, "Cancel"),
                ($setup.leadsAndContactsList.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button default primary send",
                      disabled: !$setup.selectedLeadOrContactId,
                      onClick: $setup.onSendToLeadOrContact
                    }, "Send", 8, _hoisted_22))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "button default primary send",
                      onClick: $setup.sendReservationLinkToNewLead
                    }, "Save & Send"))
              ])
            ])
          ]),
          key: "0"
        }
      : {
          name: "content",
          fn: _withCtx(() => [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "spinner-wrapper" }, [
              _createElementVNode("div", { class: "spinner" })
            ], -1))
          ]),
          key: "1"
        }
  ]), 1032, ["isOpen"]))
}